<template>
  <el-dialog
    title="编辑资料"
    :visible.sync="dialogVisible"
    :before-close="cancel"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="edit-info">
    <el-form :model="profileClone" ref="profileClone" label-width="80px">
      <el-form-item label="姓名">
        <el-input v-model="profileClone.zh_name" auto-complete="off" :disabled="confirmName"></el-input>
      </el-form-item>
      <el-form-item label="单位">
        <el-autocomplete
          v-model="school_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="科研单位">
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="职称" class="inline-block">
        <el-select v-model="profileClone.title" placeholder="请选择">
          <el-option
            v-for="(item, index) in profileClone.titles_select"
            :key="index"
            :label="item.value"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="最高学位" class="inline-block pull-right">
        <el-select v-model="profileClone.degree" placeholder="请选择">
          <el-option
            v-for="(item, index) in profileClone.degree_select"
            :key="index"
            :label="item.value"
            :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="导师类型" class="inline-block">
        <el-select v-model="profileClone.tutor" placeholder="请选择">
          <el-option
            v-for="(value, key) in profileClone.tutor_select"
            :key="key"
            :label="value"
            :value="value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="邮箱"
        class="inline-block pull-right"
        prop="email"
        :rules="{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }">
        <span :class="profileClone.email_hide ? 'status-hide' : 'status-show'" v-if="profileClone.email">
          <span class="text" title="profileClone.email">{{profileClone.email}}</span>
          <el-tooltip class="item" effect="dark" :content="!profileClone.email_hide ? '点此隐藏邮箱' : '点此显示邮箱'" placement="top-end">
            <i :class="`iconfont icon--${profileClone.email_hide ? 'hide' : 'show'}`" @click="switchHide"></i>
          </el-tooltip>
        </span>
        <template v-else>
          <a :href="`${acagridOrigin}/index/user/personal_info`" target="_blank">
            <el-button type="primary" plain round size="mini" style="width: 150px;">立即绑定</el-button>
          </a>
        </template>
      </el-form-item>
      <el-form-item label="研究方向">
        <el-tag
          :key="index"
          v-for="(item, index) in profileClone.user_tags"
          v-if="item.del != 0"
          closable
          :disable-transitions="false"
          size="mini"
          @close="handleClose(item, index)">
            {{item.tag_name}}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="tagValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
          maxlength="40"
        >
        </el-input>
        <el-button v-else type="primary" plain round size="mini" @click="showInput" icon="el-icon-plus" style="vertical-align: top;">添加研究方向</el-button>

      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="save('profileClone')">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import Tag from '@/components/Tag/index'
import {schoolNameSuggestion, getCommonEnnames} from '@/api/index'
export default {
  props: {
    dialogVisible: Boolean,
    profile: Object,
    emailHide: Number
  },
  data () {
    return {
      loading: false,
      inputVisible: false,
      tagValue: '',
      profileClone: {...JSON.parse(JSON.stringify(this.profile)), email_hide: this.emailHide},
      options: this.profile.schools,
      schoolsClone: JSON.parse(JSON.stringify(this.profile.schools)),
      school_name: this.profile.school_name,
      school_id: this.profile.school_id,
      confirmName: Boolean(parseInt(this.profile.confirm_name))
    }
  },
  computed: {
    acagridOrigin () {
      return process.env.WEB_ORIGIN
    }
  },
  methods: {
    switchHide () {
      this.$set(this.profileClone, 'email_hide', this.profileClone.email_hide ? 0 : 1)
    },
    handleClose (item, index) {
      // 如果是新建的，则直接删掉，如果是已经存在的，则把del置为0
      if (item.tag_id) {
        this.$set(item, 'del', 0)
      } else {
        this.profileClone.user_tags.splice(index, 1)
      }
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm () {
      let inputValue = this.tagValue
      if (inputValue) {
        let object = {
          user_id: this.profileClone.id,
          tag_id: 0,
          tag_name: inputValue,
          del: this.profileClone.id
        }
        this.profileClone.user_tags.push(object)
      }
      this.inputVisible = false
      this.tagValue = ''
    },
    cancel () {
      this.$emit('closeDialog')
    },
    save (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 根据 school_name 更新 school_id
          let schoolId = null
          this.options.forEach((item) => {
            if (item.value === this.school_name) {
              schoolId = item.id
            }
          })
          if (schoolId) {
            this.$set(this.profileClone, 'school_id', schoolId)
          }
          if (this.school_name) {
            this.$set(this.profileClone, 'school_name', this.school_name)
          }
          // 已确认姓名则根据中文名生成八中英文名格式
          if (!this.confirmName) {
            getCommonEnnames({
              realname: this.profileClone.zh_name
            }).then((res) => {
              this.$set(this.profileClone, 'en_name', res.data[0])
            }).catch((err) => console.log(err))
          }
          this.$emit('updateProfile', this.profileClone)
        } else {
          this.$message.error('邮箱格式不正确')
          return false
        }
      })
    },
    querySearchAsync (queryString, cb) {
      let results = null
      if (queryString) {
        this.createStateFilter(queryString, function (results) {
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            cb(results)
          }, 3000 * Math.random())
        }.bind(this))
      } else {
        results = this.schoolsClone
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          cb(results)
        }, 3000 * Math.random())
      }
    },
    createStateFilter (queryString, callback) {
      schoolNameSuggestion({
        keywords: queryString
      })
        .then((data) => {
          this.options = data.data.schools
          callback(this.options)
        })
        .catch((err) => { console.log(err) })
    }
  },
  components: {
    Tag
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>
<style lang="scss" scoped>
  .el-form-item{
    &.inline-block{
      width: 49%;
    }
    .el-select{
      width: 100%;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/Index/EditInfor/index.vue